import tw, { styled } from 'twin.macro';

import { fadeInAnimation } from '../../../shared/utils';

export const Container = styled.div`
  ${tw`w-full overflow-auto h-full pb-10`};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: var(--form-border-radius);

  ${({ inForm }) =>
    !inForm &&
    `
    width: var(--form-width);
  `}

  ${({ inForm }) =>
    inForm &&
    `
    height: fit-content;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px;
    @media screen and (min-width: 769px) {
      width: var(--form-width);
    }
  `}

  ${({ inForm, layoutType }) =>
    inForm &&
    (layoutType === 'flex-start' || layoutType === 'flex-end') &&
    `
    width: 100%;
    @media screen and (min-width: 769px) {
      width: 52%;
    }
  `}

  ${({ enableTimer }) =>
    enableTimer &&
    `
    @media screen and (min-width: 769px) {
      min-width: 600px;
    }
  `}

  ${({ formPageStyles }) => formPageStyles};

  margin-bottom: 50px !important;
`;

export const FormPageBackgroundWrapper = styled.div`
  ${fadeInAnimation};
  ${tw`relative h-full`}

  width: 100%;

  &#hide {
    display: none;
  }

  ${({ customCss }) =>
    customCss &&
    `
      && {
        ${customCss.replace(/;/g, ' !important;')}
      }
    `}
`;

export const FormPageBackground = styled.div`
  ${tw`px-28 py-4 h-full flex`}
  justify-content: var(--form-dir);
  min-height: 100%;

  @media screen and (max-width: 768px) {
    ${tw`pb-0`}
  }

  ${({ inCustomise }) =>
    inCustomise &&
    `
    padding-left: 20px;
    padding-right: 20px;

    @media screen and (min-width: 769px) {
      padding-left: 40px;
      padding-right: 40px;
    }
  `}

  ${({ customBackground }) =>
    customBackground &&
    `
    background-color: ${customBackground};
    background-repeat: repeat;
  `}
  
  ${({ inForm }) =>
    inForm &&
    `
    padding: 0;
    height: fit-content;

    @media screen and (min-width: 769px) {
      padding: 4rem 0;
    }
  `}

  ${({ inForm, formSubmitted }) => inForm && formSubmitted && `overflow:hidden;height: 100vh;`};

  direction: ${({ formDirection }) => (formDirection === 'default' ? 'ltr' : 'rtl')};

  ${({ inForm, layoutType }) =>
    inForm &&
    layoutType &&
    `
    @media screen and (min-width: 769px) {
      padding-left: ${layoutType === 'flex-start' ? '4rem' : '0'};
      padding-right: ${layoutType === 'flex-end' ? '4rem' : '0'};
    }
  `}

  ${({ pageBackground }) => pageBackground};
`;

export const FormControlsWrapper = styled.div``;

export const FormControlsFlexWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ enableTimer, timerPosition }) =>
    enableTimer &&
    timerPosition === 'bottom' &&
    `
    flex-direction: column-reverse;
    padding-bottom: 30px;
  `}
`;

export const FormControls = styled.div``;

export const SubmitButtonWrapper = styled.div`
  ${tw`flex flex-row justify-center py-8 p-4`};
`;

export const WatermarkWrapper = styled.div`
  ${tw`flex flex-col justify-center items-center px-5 pt-10`};
  font-family: var(--font-family) !important;
  color: var(--form-text-color);

  a {
    font-family: var(--font-family) !important;
    text-decoration: underline !important;

    &#formplus_link {
      color: #00afbf !important;
    }

    &#report_abuse_link {
      color: var(--form-text-color, #777) !important;
    }
  }
`;

export const PaymentModalWrapper = styled.div`
  .close-icon {
    ${tw`absolute cursor-pointer`}
    background: transparent;
    border: none;
    right: 6px;
    top: 12px;
  }

  .header {
    font-family: var(--formFontType, Circular Std) !important;
    ${tw`px-4 md:px-12 pt-8 pb-6 md:py-8`};
    background-color: rgba(0, 159, 197, 1);
    font-weight: 450;
    color: #ffffff;

    h1 {
      font-family: var(--formFontType, Circular Std) !important;
      line-height: 30px;
      font-size: 24px;
    }

    h2 {
      font-family: var(--formFontType, Circular Std) !important;
      font-size: var(--formFontSize, 14px);
      line-height: 17.71px;
      font-weight: 100;
      margin: 0;
    }
  }

  .content {
    ${tw`px-4 md:px-12 pt-4 md:pt-8`};
  }

  .footer {
    ${tw`px-4 py-6 md:px-12 md:py-10 flex justify-end`};

    .complete-button {
      ${tw`relative px-6 py-4 cursor-pointer text-white bg-fplsBlue border-none outline-none`};
      font-family: var(--formFontType, Circular Std) !important;
      border-radius: 5px;

      .tooltip {
        ${tw`absolute font-normal m-0 bg-white text-center rounded`};
        font-family: var(--formFontType, Circular Std) !important;
        box-shadow: 0px 4px 12px 0px rgba(97, 82, 244, 0.1);
        font-size: var(--formFontSize, 0.85rem);
        border: 0.2px solid #8fcaf5;
        transition: all 0.3s;
        line-height: 1.5rem;
        padding: 1.2rem;
        color: #353535;
        display: none;
        z-index: 12;
        right: 110%;
        width: 200%;
        top: -1rem;

        @media screen and (max-width: 320px) {
          width: 162%;
        }

        &:after {
          ${tw`absolute w-0 h-0`};
          border-color: white transparent transparent white;
          box-shadow: -1px -1px 0 0 #8fcaf5;
          border-radius: 2px 0px 0px 0px;
          -webkit-transition: all 0.2s;
          transform: rotate(136deg);
          transition: all 0.2s;
          border-style: solid;
          border-width: 5px;
          content: '';
          right: -5px;
          top: 30px;
        }
      }

      &:hover {
        .tooltip {
          ${tw`block`}
        }
      }

      :disabled {
        background: rgba(170, 170, 170, 1);
      }
    }
  }
`;

export const ESignPreviewModalWrapper = styled.div`
  ${tw`overflow-hidden flex flex-col justify-between h-full`};
  font-family: var(--font-family) !important;

  html,
  body,
  iframe,
  embed {
    background-color: white !important;
    background: white !important;
    overflow: hidden !important;
    height: 100% !important;
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    border: 0 !important;
  }

  @media (max-width: 512px) {
    border-radius: 0 !important;
  }

  .close-icon {
    ${tw`absolute cursor-pointer w-10 h-10`};
    background: transparent;
    border: none;
    right: 16px;
    top: 18px;

    @media (max-width: 512px) {
      background-color: #0093b6;
      padding: 2px;
      height: 30px;
      width: 30px;
      top: -30px;
      left: 0;
    }
  }

  .header {
    background-color: rgba(0, 159, 197, 1);
    ${tw`px-4 md:px-8 py-3 md:py-6`};

    h1 {
      font-family: var(--font-family) !important;
      line-height: 30px;
      font-weight: 450;
      font-size: 24px;
      color: #ffffff;

      @media (max-width: 512px) {
        font-size: 18px;
      }
    }
  }

  .content {
    ${tw`relative overflow-auto p-4 md:p-8 text-center flex-grow`};

    .pdf-doc {
      height: 100%;
    }

    .pdf-page {
      ${tw`overflow-auto w-auto h-auto`};
      border-radius: 7px;
      max-height: 100%;
      max-width: 100%;

      &::-webkit-scrollbar {
        background-color: #f5f5f5;
        width: 8px;
      }

      > .react-pdf__Page__canvas {
        width: 100% !important;
      }

      @media screen and (max-width: 768px) {
        &::-webkit-scrollbar {
          width: 6px;
        }
      }
    }

    .pdf-pagination {
      ${tw`flex gap-1 left-1/2 transform -translate-x-1/2 absolute rounded bg-white bottom-2.5 items-center justify-center`};
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

      > button {
        ${tw`m-0 p-2.5 flex border-0 items-center cursor-pointer justify-center`};

        :hover {
          background-color: #ccc;
        }
      }

      > p {
        font-family: 'Inter' !important;
        font-weight: 400 !important;
        font-size: 11px;
        ${tw`m-0 p-0`};
        color: #333;
      }
    }
  }

  .error {
    font-family: var(--font-family) !important;
    ${tw`text-red-500 text-sm font-medium`};
  }

  .footer {
    ${tw`px-4 md:px-8 pt-4 pb-6 md:py-6 gap-4 flex flex-col justify-between items-end`};
    border-top: 0.5px solid #7d7c7c;

    small {
      ${tw`text-green-600 font-semibold`};
    }

    p {
      font-family: var(--font-family) !important;
      margin-bottom: 0;
      font-weight: 450;
      text-align: left;
      font-size: 14px;
      color: #252525;

      @media (max-width: 512px) {
        font-size: 12px;
      }

      span {
        ${tw`block`};
        font-family: var(--font-family) !important;

        a {
          ${tw`text-fplsBlue underline`};
          font-weight: 500;
        }
      }
    }

    .meta {
      ${tw`flex flex-col md:flex-row gap-0 md:gap-4 w-full`};

      div {
        ${tw`flex flex-col gap-1 w-full md:w-2/4 mb-4`};

        label {
          font-family: var(--font-family) !important;
          line-height: 18px;
          font-weight: 450;
          text-align: left;
          font-size: 14px;
          color: #252525;

          @media (max-width: 512px) {
            font-size: 12px;
          }
        }

        input {
          ${tw`w-full bg-white rounded px-4 py-3 outline-none disabled:cursor-not-allowed disabled:bg-gray-100`};
          font-family: var(--font-family) !important;
          border: 0.5px solid #aaaaaa;
          font-family: Inter;
          line-height: 17px;
          font-weight: 400;
          font-size: 14px;

          &::placeholder {
            color: #dbdbdb;
          }
        }

        .error {
          ${tw`w-full mb-0`};
        }
      }
    }

    .proceed-button {
      ${tw`relative px-10 py-3 cursor-pointer text-white bg-fplsBlue border-none outline-none`};
      border-radius: 3px;

      :disabled {
        background: rgba(170, 170, 170, 1);
      }
    }
  }
`;

export const LoaderWrapper = styled.div`
  ${tw`mx-auto h-full w-52 flex flex-col gap-8 items-center justify-center`};

  svg {
    stroke: #00a0c6;
  }
`;

export const ReshowIntroPage = styled.button`
  border: none;
  outline: none;
  display: block;
  margin-left: auto;
  margin-bottom: 10px;
  text-transform: capitalise;
  background-color: transparent;
  cursor: pointer;

  color: var(--form-body-label-color, var(--form-text-color));
  font-size: var(--form-size);
  font-family: var(--font-family) !important;
  font-weight: 500;
  transition: 200ms;

  :hover {
    text-decoration: underline;
    font-weight: 600;
  }
`;
